import "./styles/index.scss";
import { Settings } from "luxon";
Settings.defaultLocale = "it";

export * from "./components";
export * from "./sections";
export * from "./icons";
